import { render, staticRenderFns } from "./GradeScale.vue?vue&type=template&id=6c7de038"
import script from "./GradeScale.vue?vue&type=script&lang=js"
export * from "./GradeScale.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports